// Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_PUBLIC_FIREBASE_APP_ID,
}

export const chatCollectionModel = {
  adminUser: process.env.REACT_APP_FIREBASE_ADMIN_USER as string,
  adminChats: process.env.REACT_APP_FIREBASE_ADMIN_CHAT as string,
  user: process.env.REACT_APP_FIREBASE_USER as string,
  chats: process.env.REACT_APP_FIREBASE_CHAT as string,
}
